// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1LO1j","info":"UpdateTermsInfo_info__rN-iU"};